import C1 from '../../../../assets/image/News/news_c1.webp';
import C2 from '../../../../assets/image/News/news_c2.webp';
import C3 from '../../../../assets/image/News/news_c3.webp';
import C4 from '../../../../assets/image/News/news_c4.webp';
import C5 from '../../../../assets/image/News/news_c5.webp';
import C6 from '../../../../assets/image/News/news_c6.webp';
import C7 from '../../../../assets/image/News/news_c7.webp';
import C8 from '../../../../assets/image/News/news_c8.webp';
import C9 from '../../../../assets/image/News/news_c9.webp';
import C10 from '../../../../assets/image/News/news_c10.webp';

export const EventsData = [
    {
        id: 10,
        date: "August 20, 2026",
        displayDate: "August 20, 2026",
        title: "AMD Embedded Computing Summit (ECS 2026)",
        subtitle: "Bengaluru",
        startDate: "2026-08-20T00:00:00+05:30",
        endDate: "2026-08-20T23:59:59+05:30",
        location: "Bengaluru",
        description: "IINVSYS was proud to be part of the AMD Embedded Computing Summit (ECS 2026), engaging with the wider AMD ecosystem and connecting with technology leaders, industry experts, partners, and innovators. We showcased our capabilities in leveraging AMD technologies to develop Make-in-India intelligent edge computing platforms, AI/ML solutions, and full-stack systems across Railways, Defence, Aerospace, Smart Cities, and Industrial Automation.",
        link: "https://www.linkedin.com/posts/iinvsys_iinvsys-amdembeddedcomputingsummit-ecs2026-activity-7497502968078827521-SXve",
        image: C10
    },
    {
        id: 9,
        date: "August 11, 2026",
        displayDate: "August 11, 2026",
        title: "Ecosystem Partner at AMD x86 Embedded Solution Day",
        subtitle: "Bengaluru",
        startDate: "2026-08-11T00:00:00+05:30",
        endDate: "2026-08-11T23:59:59+05:30",
        location: "Bengaluru",
        description: "The IINVSYS team is proud and delighted to participate as an Ecosystem Partner at AMD x86 Embedded Solution Day Bengaluru 2026. We showcased our indigenously designed and manufactured Edge Intelligence Platforms and Solutions, powered by AMD x86 technology, enabling the next generation of intelligent and autonomous applications across industrial automation, smart railways, robotics, infrastructure, and aerospace & Defence.",
        link: "https://www.linkedin.com/posts/amd-bengaluru-iinvsys-ugcPost-7492813188342849536-p6aX/?utm_source=share&utm_medium=member_desktop&rcm=ACoAABS2Z5QBcA76rp3gqTGvXisTmsioPB5_oKo",
        image: C9
    },
    {
        id: 8,
        title: "The Minds Behind Intelligent Automation",
        subtitle: "Coimbatore",
        startDate: "2026-01-29T10:00:00+05:30",
        endDate: "2026-01-31T18:00:00+05:30",
        displayDate: "January 29–31, 2026",
        startTime: "10:00 AM",
        location: "Stall No: 83 | Coimbatore",
        description: "Innovation doesn’t happen in isolation—it’s built by people, tested on the ground, and delivered with purpose. Live from Global Expo—Knowledge Summit 2026, our team is demonstrating how connected technology can redefine comfort, control, and efficiency.",
        link: "https://www.instagram.com/p/DULOuFlE4Rz/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        image: C8
    },
    {
        id: 7,
        title: "Smart Home Expo 2026",
        subtitle: "Mumbai",
        startDate: "2026-04-28T10:00:00+05:30",
        endDate: "2026-04-30T18:00:00+05:30",
        displayDate: "April 28–30, 2026",
        startTime: "10:00 AM",
        location: "Jio World Convention Centre, Mumbai | Booth No: K21",
        description: "At SmartHomeExpo2026, Mumbai, IINVSYS stood out as a truly unique Indian OEM in Home, Building, and Industrial Automation. Across 3 days, the response was remarkable; visitors, distributors, and partners from across India consistently recognized our distinct positioning and actively sought to engage with us.",
        link: "https://www.linkedin.com/posts/iinvsys_smarthomeexpo2026-iinvsys-iinvsys-activity-7456732304309379072-Jyox?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFW9L2kBqWFwOIKY3FeeT6bZum2PEseCGik",
        image: C7, // Placeholder or specific image
        isUpcoming: true // Flag to prioritize for the main banner
    },
    {
        id: 6,
        date: "April 18, 2026",
        displayDate: "April 18, 2026",
        title: "Representing Puducherry’s Tech Excellence",
        subtitle: "New Delhi",
        description: "We were deeply honoured to have welcomed the Lieutenant Governor of New Delhi, H.E. Shri Taranjit Singh Sandhu, to our stall. His Excellency engaged with our team, explored our solutions first-hand, and appreciated our hashtag#TrulyMakeinIndia products.",
        link: "https://www.linkedin.com/posts/iinvsys_puducherry-indiasoft2026-trulymakeinindia-activity-7450937522722971648-Hi3E",
        image: C6,
        startDate: "2026-04-18T00:00:00+05:30",
        endDate: "2026-04-18T23:59:59+05:30",
        location: "INDIASOFT 2026, New Delhi"
    },
    {
        id: 5,
        date: "April 16, 2026",
        displayDate: "April 16, 2026",
        title: "Global Innovation Showcase at INDIASOFT 2026",
        subtitle: "New Delhi",
        description: "We are proud to share that #IINVSYS participated in #INDIASOFT2026, one of India’s leading global platforms connecting technology innovators, engineering companies, and international business leaders.",
        link: "https://www.linkedin.com/posts/iinvsys_indiasoft2026-iinvsys-indiasoft2026-activity-7449104049213292544-_rcl",
        image: C5,
        startDate: "2026-04-16T00:00:00+05:30",
        endDate: "2026-04-16T23:59:59+05:30",
        location: "INDIASOFT 2026, New Delhi"
    },
    {
        id: 4,
        date: "March 12-14, 2026",
        displayDate: "March 12-14, 2026",
        title: "Inspiring the Next Generation of Engineers",
        subtitle: "Chennai",
        description: "At hashtag#IRCE2026 at ICF Stadium, IINVSYS had the privilege of extending the expo experience beyond industry engagement by giving students from Vasavi International School an opportunity to explore the future of railway innovation.",
        link: "https://www.linkedin.com/posts/iinvsys_irce2026-irce2026-iinvsys-activity-7447289600068284416-Anx9",
        image: C4,
        startDate: "2026-03-12T00:00:00+05:30",
        endDate: "2026-03-14T23:59:59+05:30",
        location: "ICF Stadium, Chennai"
    },
    {
        id: 3,
        date: "March 12-14, 2026",
        displayDate: "March 12-14, 2026",
        title: "Prestigious Visit from ICF Senior Leadership",
        subtitle: "Chennai",
        description: "At the International Rail Coach Expo 2026 (#IRCE2026) at ICF Stadium, #IINVSYS proudly participated with a clear vision — to support the railway industry through scalable, reliable, and future-ready innovation. ",
        link: "https://www.linkedin.com/posts/iinvsys_irce2026-iinvsys-makeinindia-activity-7445079670057857024-LzLZ",
        image: C3,
        startDate: "2026-03-12T00:00:00+05:30",
        endDate: "2026-03-14T23:59:59+05:30",
        location: "ICF Stadium, Chennai"
    },
    {
        id: 2,
        date: "March 12-14, 2026",
        displayDate: "March 12-14, 2026",
        title: "Visionary Solutions for Next-Gen Railways",
        subtitle: "Chennai",
        description: "A proud and prestigious moment for the #IINVSYS team at #IRCEEXPO2026, welcoming the esteemed Subba Rao U, General Manager of Integral Coach Factory, and senior leadership to our stall.",
        link: "https://www.linkedin.com/posts/iinvsys_iinvsys-irceexpo2026-trulymakeinindia-activity-7445130394213150720-0DWf",
        image: C2,
        startDate: "2026-03-12T00:00:00+05:30",
        endDate: "2026-03-14T23:59:59+05:30",
        location: "ICF Stadium, Chennai"
    },
    {
        id: 1,
        date: "March 12-14, 2026",
        displayDate: "March 12-14, 2026",
        title: "Strategic Engagement with ICF Leadership",
        subtitle: "Chennai",
        description: "It was a privilege and honour to interact with the leadership team of Integral Coach Factory (ICF), Ministry of Railways, during the International Rail Coach Expo2026 (IRCE2026), held at ICF Stadium from 12th to 14th March 2026.",
        link: "https://www.linkedin.com/posts/iinvsys_expo2026-irce2026-irce2026-ugcPost-7445527607716265985-3hjR",
        image: C1,
        startDate: "2026-03-12T00:00:00+05:30",
        endDate: "2026-03-14T23:59:59+05:30",
        location: "ICF Stadium, Chennai"
    }
];
